import {defineAsyncComponent} from 'vue';

const examinationResultPopup = defineAsyncComponent(() => import('@/views/checkNorm/ExaminationResultPopup.vue'));

export function examinationResultRegister(app) {
  app.component('ExaminationResultPopup', examinationResultPopup);
}
